import './App.css';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import Box from '@mui/material/Box';

import {Web} from './pages'

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: [
        'Merriweather', 'serif'
      ].join(','),
    },});
  return (

    <ThemeProvider theme={theme}>
      <Box>
        <Web/>
      </Box>
    </ThemeProvider>
    
  )
}

export default App;
